/**
 * Mount deferred E3 landing sections (data-e3-defer-root / template).
 * Required on page templates that reuse product E3 sections without product-template.
 */
(function () {
  if (window.__e3PerfBooted) return;
  window.__e3PerfBooted = true;

  function activateVideo(video) {
    if (!video || video.dataset.e3LazyReady === '1') return;
    video.dataset.e3LazyReady = '1';

    var sources = video.querySelectorAll('source[data-src]');
    if (sources.length) {
      sources.forEach(function (source) {
        if (!source.getAttribute('src')) {
          source.setAttribute('src', source.getAttribute('data-src'));
        }
      });
    } else if (video.dataset.src && !video.getAttribute('src')) {
      video.setAttribute('src', video.dataset.src);
    }

    video.preload = 'metadata';
    try {
      video.load();
    } catch (e) {}

    if (video.hasAttribute('data-e3-autoplay')) {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  function observeVideo(video) {
    if (!('IntersectionObserver' in window)) {
      activateVideo(video);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            if (!video.paused) video.pause();
            return;
          }
          activateVideo(video);
          if (video.hasAttribute('data-e3-autoplay')) {
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.15 }
    );
    io.observe(video);
  }

  function bootVideos(root) {
    (root || document).querySelectorAll('video[data-e3-lazy]').forEach(observeVideo);
  }

  function isExecutableScript(script) {
    var type = (script.getAttribute('type') || 'text/javascript').trim().toLowerCase();
    return (
      !type ||
      type === 'text/javascript' ||
      type === 'application/javascript' ||
      type === 'module'
    );
  }

  function runScripts(container) {
    var scripts = Array.prototype.slice.call(container.querySelectorAll('script'));
    scripts.forEach(function (oldScript) {
      if (!isExecutableScript(oldScript)) return;
      var s = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attr) {
        s.setAttribute(attr.name, attr.value);
      });
      if (oldScript.src) {
        s.src = oldScript.src;
      } else {
        s.textContent = oldScript.textContent;
      }
      oldScript.parentNode.replaceChild(s, oldScript);
    });
  }

  function mountRoot(root) {
    if (!root || root.dataset.e3Mounted === '1') return;
    var tpl = root.querySelector('template[data-e3-defer-template]');
    if (!tpl) return;
    root.dataset.e3Mounted = '1';
    var frag = tpl.content.cloneNode(true);
    root.innerHTML = '';
    root.appendChild(frag);
    runScripts(root);
    bootVideos(root);
    root.style.minHeight = '';
  }

  function observeRoots() {
    var roots = document.querySelectorAll('[data-e3-defer-root]');
    if (!roots.length) return;

    if (!('IntersectionObserver' in window)) {
      roots.forEach(mountRoot);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          mountRoot(entry.target);
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '400px 0px', threshold: 0.01 }
    );

    roots.forEach(function (root) {
      io.observe(root);
    });

    var prefetch = function () {
      if (roots[0] && roots[0].dataset.e3Mounted !== '1') mountRoot(roots[0]);
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(prefetch, { timeout: 5000 });
    } else {
      setTimeout(prefetch, 3500);
    }
  }

  function boot() {
    bootVideos(document);
    observeRoots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
